// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"MainPage_gridContainer__2lJ1-","header":"MainPage_header__1oCdN","pages":"MainPage_pages__3PD_U"};